import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarRef } from '@angular/material/snack-bar';
import { WINDOW } from '@ng-web-apis/common';

@Component({
  selector: 'pd-update-available',
  standalone: true,
  imports: [MatButtonModule],
  templateUrl: './update-available.component.html',
  styleUrls: ['./update-available.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpdateAvailableComponent {
  private window = inject(WINDOW);

  snackBarRef = inject(MatSnackBarRef);

  reload() {
    this.window.location.reload();
    this.snackBarRef.dismiss();
  }
}
